import { useEffect, useRef } from "react";
import TagManager from "react-gtm-module";

const GTM_ID = process.env.REACT_APP_GTM_ID;

export default function GTMProvider({ children }) {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current || !GTM_ID) return;
    if (!GTM_ID) {
      console.warn("GTM_ID missing");
      return;
    }

    try {
      TagManager.initialize({
        gtmId: GTM_ID,
        // dataLayer: {}
      });
      initializedRef.current = true;
    } catch (error) {
      console.error("GTM init failed", error);
    }
  }, []);

  return children;
}
